/* Generated USDT deposit helpers unit. */
/* global BigInt */
// Eligibility belongs to authenticated settings; legacy crypto_enabled omits auto_charge.
export const getDepositMode = (settings) =>
  ['manual', 'automatic'].includes(settings?.crypto_deposit_mode)
    ? settings.crypto_deposit_mode : 'unavailable';
export const isTrc20Address = value => typeof value === 'string' && /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(value.trim());
const effectiveRate = (value) => typeof value === 'number' || (typeof value === 'string' && value.trim()) ? Number(value) : NaN;
export const getManualDepositPolicy = (settings) => {
  const address = typeof settings?.usdt_headquarters_wallet_address === 'string'
    ? settings.usdt_headquarters_wallet_address.trim() : '';
  const rate = effectiveRate(settings?.usdt_exchange_rate);
  const error = !address ? '본사 USDT 입금 주소가 등록되지 않았습니다. 고객센터에 문의해주세요.' : !isTrc20Address(address) ? '본사 USDT 입금 주소 형식이 올바르지 않습니다. 고객센터에 문의해주세요.' : !(Number.isFinite(rate) && rate > 0) ? 'USDT 환율을 확인할 수 없습니다. 잠시 후 다시 확인해주세요.' : '';
  return { address, rate, ready: getDepositMode(settings) === 'manual' && !error, error };
};
// Display truncation only. Deposit requests continue to send the entered KRW amount.
export const convertedUsdt = (amount, rate) => {
  if (!Number.isFinite(Number(amount)) || !Number.isFinite(Number(rate))) return null;
  const value = Number(amount) / Number(rate);
  if (!Number.isFinite(value) || Number(amount) < 0 || !(Number(rate) > 0)) return null;
  if (value < 0.01) return '0.00';
  if (value >= 1e21) return `${BigInt(value)}.00`;
  const [whole, fraction = ''] = String(value).split('.');
  return `${whole}.${fraction.slice(0, 2).padEnd(2, '0')}`;
};
export const walletOwnerKey = (profile) => String(profile?.id || profile?.user_id || profile?.member_id || profile?.user_unique_id || profile?.username || 'guest');

export const getUsdtWithdrawalPolicy = (settings, value) => {
  const address = typeof value === 'string' ? value.trim() : '';
  const rate = effectiveRate(settings?.usdt_exchange_rate);
  const error = settings?.crypto_withdrawal_enabled !== true ? '현재 USDT 출금을 이용할 수 없습니다.' : !address ? '등록된 USDT 출금 지갑 주소가 없습니다. 내 정보에서 등록하거나 고객센터에 문의해주세요.' : !isTrc20Address(address) ? '등록된 지갑 주소 형식이 올바르지 않습니다. T로 시작하는 34자리 TRC-20 주소를 확인해주세요.' : !(Number.isFinite(rate) && rate > 0) ? 'USDT 환율을 확인할 수 없습니다. 잠시 후 다시 확인해주세요.' : '';
  return { address, rate, ready: !error, error };
};

export const isUsdtHistoryRow = (row) => row?.request_channel === 'usdt' || (!row?.request_channel && row?.money_type === 'usdt');
